export const postUpsellPage = [
  'szh3re-2z',
  // '9ff43a-25',
  'xp11wd-tz',
  'm7bwmk-nm',
  'f624ed-65',
  '83802a-27',
  // '933062-bc',
  'tbsgzu-st',
  'gcayw5-k0',
  // '04c908',
  'd9f629-3',
  '2crgew-hs',
  'abi-store-for-test',
];
